import type { MouseEvent } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

export const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const openConsent = useCallback(() => {
    window.regaiConsentManager?.open();
  }, []);

  const handleAnchor = (event: MouseEvent<HTMLAnchorElement>, id: string) => {
    if (location.pathname.startsWith('/social')) {
      return;
    }
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-white/10 py-8 text-sm bg-[linear-gradient(135deg,rgba(12,14,44,0.95)_0%,rgba(40,80,245,0.2)_45%,rgba(91,63,246,0.15)_100%)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Link to="/">
            <img
              src="/logo.jpeg"
              alt={t('footer.brandAlt', 'RegAI logo')}
              className="h-9 w-auto rounded-lg shadow"
              loading="lazy"
              decoding="async"
            />
          </Link>
          <div>
            <div className="font-semibold">{t('footer.brand')}</div>
            <div className="text-white/70">{t('footer.company')}</div>
          </div>
        </div>

        <nav className="flex items-center gap-6" aria-label="Footer navigation">
          <Link
            to="/#privacy"
            onClick={(event) => handleAnchor(event, 'privacy')}
            className="hover:text-regai-accent transition-colors"
            aria-label={t('footer.links.ariaPrivacy')}
          >
            {t('footer.links.labels.0')}
          </Link>
          <button
            type="button"
            onClick={openConsent}
            className="hover:text-regai-accent transition-colors"
            aria-label={t('footer.links.ariaCookies')}
          >
            {t('footer.links.labels.1')}
          </button>
          <Link
            to="/#contatti"
            onClick={(event) => handleAnchor(event, 'contatti')}
            className="hover:text-regai-accent transition-colors"
            aria-label={t('footer.links.ariaContacts')}
          >
            {t('footer.links.labels.2')}
          </Link>
        </nav>
      </div>
    </footer>
  );
};
